import React, { useMemo } from "react";
// import localforage from "localforage";
import { checkHasPermission } from "@/helpers/checkHasPermission";

// const HasPermission = props => {
//   const [hasPermission, setHasPermission] = useState(false);

//   const checkHasPermission = useCallback(async () => {
//     // get the user role permission
//     const userPermissions = await localforage.getItem("userPermissions");
//     if (userPermissions) {
//       const isPermission =
//         !props.permission || userPermissions.includes(props.permission);
//       setHasPermission(!!isPermission);
//     }
//   }, [props.permission]);

//   useEffect(() => {
//     checkHasPermission();
//   }, [checkHasPermission]);

//   if (typeof props.children === "function") {
//     return <>{props.children(hasPermission)}</>;
//   }

//   return hasPermission ? <>{props.children}</> : "";
// };

const HasPermission = props => {
  const hasPermission = useMemo(() => {
    if (props.permissions && Array.isArray(props.permissions)) {
      return props.permissions.map(permission => checkHasPermission(permission)).every(v => v)
    }
    return checkHasPermission(props.permission);
  }, [props.permission]);

  if (typeof props.children === "function") {
    return <>{props.children(hasPermission)}</>;
  }

  return hasPermission ? <>{props.children}</> : null;
};

export default HasPermission;
